import { render, staticRenderFns } from "./UsersSettings.vue?vue&type=template&id=2a04c15c&"
import script from "./UsersSettings.vue?vue&type=script&setup=true&lang=js&"
export * from "./UsersSettings.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UsersSettings.vue?vue&type=style&index=0&id=2a04c15c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports